<template>

    <div class="">

        <v-row>
            <v-col
                cols="12"
                md="2"
            >
            <span class="font-weight-light input-span">
                {{ $t('reports.title') }}:
            </span>
            </v-col>

            <v-col
                cols="12"
                md="10"
            >
            <span class="input-span">
                {{ reportTitle }}
            </span>
            </v-col>
        </v-row>

        <v-row>
            <v-col
                cols="12"
                md="2"
            >
            <span class="font-weight-light input-span">
                {{ $t('reports.academic_period') }}:
            </span>
            </v-col>

            <v-col
                cols="12"
                md="10"
            >
            <span class="input-span">
                {{ academicPeriod }}
            </span>
            </v-col>
        </v-row>

        <div v-if="reportSubtype != null">
            <v-row>
                <v-col
                    cols="12"
                    md="2"
                >
            <span class="font-weight-light input-span">
                {{ $t('reports.report_subtype') }}:
            </span>
                </v-col>

                <v-col
                    cols="12"
                    md="10"
                >
            <span class="input-span">
                {{ reportSubtype }}
            </span>
                </v-col>
            </v-row>
        </div>

        <div v-if="programs != null">
            <v-row>
                <v-col
                    cols="12"
                    md="2"
                >
            <span class="font-weight-light input-span">
                {{$t('reports.create_form.report_with_selected_programs')}}:
            </span>
                </v-col>

                <v-col
                    cols="12"
                    md="10"
                >
            <span class="input-span" v-for="program in programs">
                <li>{{program}}</li>
            </span>
                </v-col>
            </v-row>
        </div>

        <v-row>
            <v-col
                cols="12"
                md="2"
            >
            <span class="font-weight-light input-span">
                {{ $t('reports.data_sources') }}:
            </span>
            </v-col>

            <v-col
                class="pt-0"
                cols="12"
                md="10"
            >
                <span
                    v-for="dataSource in dataSources"
                    class="pl-0"
                    :key="dataSource.id"
                >
                    <li>
                        <span class="input-span">{{ dataSource.title }} <span class="font-weight-thin">({{ formattedDataSourceType(dataSource) }})</span> </span>
                    </li>
                </span>
            </v-col>
        </v-row>
    </div>

</template>

<script>

export default {
    name: "ReportGenerationConfirmation",

    props: {
        reportTitle: {
            type: String,
            required: true,
        },
        academicPeriod: {
            type: String,
            required: true,
        },
        reportSubtype: {
            type: String ||null,
            required: false,
            nullable: true
        },
        programs: {
            type: Array ||null,
            required: false,
            nullable: true
        },
        dataSources: {
            type: Array,
            required: true,
        },
    },

    data(){
          return{
              rules: {
                  reportTitle: [
                      v => !!v || i18n.t('reports.create_form.required_fields.report_title'),
                  ],

                  academicPeriod: [
                      v => !!v || i18n.t('reports.create_form.required_fields.academic_period'),
                  ],

              },
          }
    },

    methods: {

        /**
         * Validation of the old bible reference to rename it to -> RECU
         *
         * @param {Object} dataSource
         *
         * @returns {VueI18n.TranslateResult|string}
         */
        formattedDataSourceType(dataSource) {
            return dataSource.class === 'BIBLE'
                ? this.$t('reports.data_source_types.bible')
                : dataSource.class;
        },

    }
}
</script>

<style scoped>

</style>
